import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { categoryColorMap } from '@/mocks/categories';
import { categories } from '@/mocks/categories';

function getCategoryColor(slug: string) {
  const cat = categories.find((c) => c.slug === slug);
  if (!cat) return { bg: 'bg-primary-100', text: 'text-primary-700' };
  return categoryColorMap[cat.color] || { bg: 'bg-primary-100', text: 'text-primary-700' };
}

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const cat = categories.find((c) => c.slug === article.category);
  const catName = cat?.name || article.category;
  const colors = getCategoryColor(article.category);

  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-colors hover:border-primary-300/50">
      <Link to={`/article/${article.slug}`}>
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3">
            <span className={`px-2.5 py-1 rounded-md text-xs font-medium ${colors.bg} ${colors.text}`}>
              {catName}
            </span>
          </div>
          {article.rating >= 9 && (
            <div className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
              高分 {article.rating}
            </div>
          )}
        </div>
      </Link>
      <div className="p-4">
        <Link to={`/article/${article.slug}`}>
          <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.views >= 10000
                ? `${(article.views / 10000).toFixed(1)}万`
                : article.views}
            </span>
            <span>{article.date}</span>
          </div>
          <span>{article.author}</span>
        </div>
      </div>
    </article>
  );
}